import React, { useContext, useState } from "react";
import {
	MenuFoldOutlined,
	MenuUnfoldOutlined,
	UserOutlined,
} from "@ant-design/icons";
import {
	Layout,
	Button,
	Avatar,
	Space,
	Card,
	Flex,
	Popover,
	List,
	message
} from "antd";
import { UserContext } from "../../../Context";
import constants from "../../../Constants/constants";
import { getCookie, COOKIE } from "../../../Services/Cookie";
import { Link, useNavigate } from "react-router-dom";
import { fetchApi } from "../../../Services/Api";
import { badgeNotification, notificationHandler, NotificationList, logOut, updateNotificationUrl } from "../../../GlobalFunctions/GlobalFunctions";
import StudentMentorRequest from "../StudentMentorRequest";
const { Header } = Layout;

const Headers = ({ countData, updateNotificationData }) => {
	const navigate = useNavigate();
	// const profileImg = sessionStorage.getItem("profile_image") ? sessionStorage.getItem("profile_image") : localStorage.getItem("profile_image");
	const { collapsed, profileImage, toggleCollapsed, setSelectedMenuItem, setSelectedSubMenuItem, setBreadcrumbItems } = useContext(UserContext);
	const [visible, setVisible] = useState(false);
	const [isPopoverOpen, setIsPopoverOpen] = useState(false);
	const [mentorRequestModalOpen, setMentorRequestModalOpen] = useState(false);
	const [notificationId, setNotificationId] = useState(null);
	const userRoleId = getCookie(COOKIE.Role);
	const studentID = getCookie(COOKIE.UserId);
	const isStudent = userRoleId === '0'
	const username = `${getCookie(COOKIE.FirstName)} ${getCookie(COOKIE.LastName)}`

	const showProfile = () => {
		if (profileImage) return <Avatar icon={<img src={profileImage} alt="profile" />} />
		else return <Avatar icon={<UserOutlined />} />
	}

	const navigateToModule = (destination) => {
		navigate(`/${destination}`, {
			state: { editrecord: getCookie(COOKIE.UserId), isProfile: true },
		});
		setIsPopoverOpen(false);
	};

	const profileMenu = (
		<div className="profile-main" onMouseLeave={() => setIsPopoverOpen(false)}>
			<Card className="profileCard">
				{showProfile()}
				<br></br>
				<span className="profile-name">{username}</span>
			</Card>
			<Flex gap={"small"} horizontal className="profile-menu-footer">
				<Button
					className="bgGreen500"
					onClick={() => navigateToModule("student-profile")}
				>
					{constants.Profile}
				</Button>
				<Button onClick={() => navigateToModule("student-change-password")}>
					{constants.ChangePassword}
				</Button>
				<Button type="primary" onClick={logOut} danger>
					{constants.SignOut}
				</Button>
			</Flex>
		</div>
	);

	const handleNotificationClick = (notif) => {
		let semesterData = JSON.parse(sessionStorage.getItem('semesterData'))
    if (notif?.notification_url?.includes('answer-survey')) {
      notif = updateNotificationUrl(notif, semesterData)
    }
		notificationHandler(
			notif,
			navigate,
			{
				setNotificationId,
				setMentorRequestModalOpen,
				isStudent,
				setSelectedMenuItem: setSelectedMenuItem,
				setSelectedSubMenuItem: setSelectedSubMenuItem,
				setBreadcrumbItems: setBreadcrumbItems,
			}
		)
		setVisible(false);
	}

	const renderItemHeader = (item) => {
		return (
			<NotificationList
				item={item}
				onClickHandler={() => handleNotificationClick(item)}
			/>
		)
	};

	const handleOnLoadMoreClick = () => {
		sessionStorage.removeItem('selectedSubMenuItem')
		setSelectedSubMenuItem('')
		setVisible(false)
	}

	const loadMoreFunction = () => {
		return (
			<div className="view-button">
				<Button type="link" onClick={handleOnLoadMoreClick}>
					<Link to="/student-notifications">{constants.ViewMore}</Link>
				</Button>
			</div>
		)
	}

	const handleSave = (value) => {
		const payload = {
			student_id: studentID,
			value: value,
			notification_id: notificationId,
		};
		fetchApi("/student/save-mentor-request-status", "POST", payload)
			.then((res) => {
				if (res?.code === "200") {
					updateNotificationData();
					setMentorRequestModalOpen(false)
					message.success(constants.ThankYouResponse);
				} else message.error(constants.ErrorMessage);
			}).catch(() => {
				message.error(constants.ErrorMessage);
			});
	};

	return (
		<Header className="main-header">
			<Button
				type="text"
				icon={
					collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />
				}
				onClick={toggleCollapsed}
				className="text-white menu-btn !invisible md:!visible"
			/>
			<Space>
				{countData?.length > 0 ? (
					<Popover
						overlayClassName="notification-popover"
						content={
							<List
								size="large"
								className="list-size"
								bordered
								dataSource={countData?.slice(0, 5)}
								renderItem={renderItemHeader}
								loadMore={loadMoreFunction()}
							/>
						}
						trigger="click"
						open={visible}
						onOpenChange={setVisible}
					>
						{badgeNotification(countData)}
					</Popover>
				) : badgeNotification(countData)}
				<Popover
					destroyOnHidden={true}
					content={profileMenu}
					trigger="click"
					overlayClassName="profile-popover"
					open={isPopoverOpen}
					onOpenChange={(e) => setIsPopoverOpen(e)}
				>
					<Button type="text" className="text-white menu-btn">
						<Space>
							{showProfile()}
							<span className="text-white">{username}</span>
						</Space>
					</Button>
				</Popover>
			</Space>
			{
				mentorRequestModalOpen &&
				<StudentMentorRequest
					open={mentorRequestModalOpen}
					closeModal={() => setMentorRequestModalOpen(false)}
					handleSave={(e) => handleSave(e)}
				/>
			}
		</Header>
	);
};

export default Headers;
